import { useQuery } from '@tanstack/react-query'

import { getFaqs } from '@/services/faq.service'

/**
 * Whether RescueX has published at least one FAQ (RSCX-353).
 *
 * Both navs (AppSidebar and the mobile BottomNav) use this to decide whether
 * the FAQs nav item exists at all. Shares the ['faqs'] cache with the FAQs
 * page; the long staleTime keeps nav renders from re-fetching.
 */
export const usePublishedFaqs = ({ enabled = true } = {}) => {
  const { data } = useQuery({
    queryKey: ['faqs'],
    queryFn: () => getFaqs(),
    enabled,
    staleTime: 5 * 60 * 1000,
  })

  return { hasPublishedFaqs: (data?.results ?? data ?? []).length > 0 }
}
